import { faPaperPlaneTop } from '@fortawesome/pro-regular-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

import { type FC } from 'react'

import { useConversationsQuery } from 'api/conversations/queries'
import { useDebouncedSearchValue } from 'hooks/useDebouncedSearchValue'
import { useStartNewConversation } from 'hooks/useStartNewConversation'
import { useTranslation } from 'services/i18n'

import { ConversationsHistoryLink } from './ConversationsHistoryLink'

export const NewConversationButton: FC = () => {
  const { t } = useTranslation()

  const debouncedValue = useDebouncedSearchValue()

  const { isFetching } = useConversationsQuery({
    query: debouncedValue,
  })

  const { handleClickNewConversation } = useStartNewConversation()

  const handleClick = (
    event: React.MouseEvent<HTMLAnchorElement, MouseEvent>,
  ) => {
    if (isFetching) {
      return
    }

    handleClickNewConversation(event)
  }

  return (
    <ConversationsHistoryLink
      url="/"
      icon={<FontAwesomeIcon icon={faPaperPlaneTop} />}
      tooltipContent={t('conversation_history.new_conversation_button')}
      onClick={handleClick}
      title={t('conversation_history.new_conversation_button')}
      titleShort={t('conversation_history.new_conversation_button_short')}
    />
  )
}
